import React from 'react';
import { Flex, Box, Image, HStack } from '@chakra-ui/react';
import { useLocation, useMatch } from 'react-router-dom';
import PagerDutyLogo from '@/assets/images/pagerduty-black-rgb.svg';
import { paths } from '@/config/paths';
import { getAgentById } from '@/config/agent-config';
import { LAYOUT_REGISTRY } from '@/config/layout-config';
import { NavLink } from './nav-link';
import { UserMenu } from './user-menu';

export const AppHeader: React.FC = () => {
  const location = useLocation();
  const agentMatch = useMatch(paths.AssistantAgent);
  const assistantMatch = useMatch(paths.Assistant);
  const agentId = agentMatch?.params?.agentId;
  const agent = agentId ? getAgentById(agentId) : null;
  const layout = agent
    ? LAYOUT_REGISTRY[agent.layoutId]
    : assistantMatch
      ? LAYOUT_REGISTRY.onboarding
      : LAYOUT_REGISTRY.generic;

  return (
    <Flex
      as="header"
      position="sticky"
      top={0}
      zIndex={10}
      bg="gray.50"
      borderBottom="1px"
      borderColor="gray.200"
      maxH="55px"
      px={4}
      py={4}
      align="center"
      justify="space-between"
    >
      {/* Logo - Left */}
      <Box mr={5}>
        <Image src={PagerDutyLogo} alt="PagerDuty" h="25px" w="auto" />
      </Box>

      {/* Navigation Links - Center */}
      <HStack as="nav" aria-label="Main navigation" spacing={0} justifyContent="start" w="100%">
        {layout.navItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            isActive={
              location.pathname === item.to ||
              location.pathname.startsWith(item.to + '/')
            }
          >
            {item.label}
          </NavLink>
        ))}
      </HStack>

      {/* User Menu - Right */}
      <Box>
        <UserMenu />
      </Box>
    </Flex>
  );
};

export default AppHeader;
